module.exports = __webpack_public_path__ + "img/rule.90c167f8.jpg";